module.exports = __webpack_public_path__ + "img/archive.1ca25445.svg";